import { VendorPage } from 'pages/vendors';

export const VendorsView = () => {
  return <VendorPage />;
};
